import { videoAssetFragment } from "./video-asset";

export const heroFragment = `
    type,
    titles,
    description,
    assetType,
    videoAsset->{
      ${videoAssetFragment}
    },
    imageAsset
`;

export const eventFragment = `
  _id,
  _type,
  "slug": path.current,
  brand,
  seo,
  eventReference->{
    _id,
    title,
    lifecycleStatus,
    series,
    attendanceType,
    timings,
    location
  },
  hero {
    ${heroFragment}
  },
  footer
`;
